import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { BranchStatusLogEntity } from '../../domain/entities/BranchStatusLogEntity'
import type { BranchStatusLogAdminDto } from '@/backend/market'

export class BranchStatusLogModel extends BranchStatusLogEntity {
  constructor(dataDto: BranchStatusLogAdminDto) {
    super()
    mapEntityProperties<BranchStatusLogModel>(this, dataDto)
  }
}
